import { Component, Prop, h } from '@stencil/core';
import { htmlSanitizer } from '@utils/html-sanitizer';

@Component({
  tag: 'vs-icon-bundle',
})
export class IconBundle {
  @Prop() iconbundleid: string;
  @Prop() imageReference: string;
  @Prop() alignment: string;
  @Prop() altText: string;
  @Prop() title: string;
  @Prop() headerStyle: string;
  @Prop() description: string;
  @Prop() isMigrated: boolean;
  @Prop() shouldWrapDescriptionInPTags: boolean;
  @Prop() cta: string;
  @Prop() layout: string;
  @Prop() headerId : string;
  @Prop() needextraAria = true;
  

  private renderCtaLink(content: any) {
    const ctaAriaLabel = `${content.ctaTitle} ${content.ctaLinkTarget === 'external' ? (content.ctaLinkType === 'new' ? '(open_in_new_window)' : '(external_link)') : ''}`;
    
    // Format the video URL properly if only ID is provided
    let videoUrl;
    if (content.ctaLinkType === 'video') {
      // Check if it's already a full URL or just an ID
      if (content.ctaVideoId && !content.ctaVideoId.includes('youtube.com')) {
        videoUrl = `https://www.youtube.com/watch?v=${content.ctaVideoId}`;
      } else {
        videoUrl = content.ctaVideoId;
      }
    }
    
    return (
      <div class={`vs-row vs-mb-1 ${this.alignment === '' ? 'vs-justify-content-start' : 'vs-justify-content-center'}`}>
        <div class="vs-col-auto">
        <vs-link
            link-aria-label={ctaAriaLabel}
            button-color={content.ctaButtonColor || 'primary'}
            link-conversion={content.ctaConversionType}
            link-type={content.ctaLinkType}
            link-style={content.ctaStyle}
            has-dark-bg="no"
            link-target={content.ctaLinkTarget}
            link-text={content.ctaTitle}
            img-path={content.CtaVideoImagePath}
            video-title={content.CtaVideoTitle}
            video-url={videoUrl}
            link-val={content.ctaLink}
            modal-target={content.ctaUniqueId}
            is-no-follow={content.ctaNoFollow ? 'nofollow' : undefined}>
          </vs-link>
        </div>
      </div>
    );
  }

  render() {
    const ctaArray = JSON.parse(this.cta);

    return (
      <div data-gtm-card-title="icon-bundle" data-layout={this.layout} class={`vs-icon-bundle vs-pb-1 ${this.alignment === "true" ? 'vs-align-center' : 'vs-align-left'}`} {...(this.needextraAria ? { 'aria-atomic': 'false', 'aria-live': 'polite' } : {})}>
        <div class="vs-mb-1 vs-pb-1">
          <img class="vs-bundle-img" alt={this.altText || ''} src={this.imageReference} loading="lazy" />
        </div>
        {this.title &&
          (this.headerStyle === 'h3' ? <h3 class="vs-h3 vs-mb-1 vs-pb-1" innerHTML={htmlSanitizer(this.title)}></h3>
            : this.headerStyle === 'h4' ? <h4 class="vs-h4 vs-mb-1 vs-pb-1" innerHTML={htmlSanitizer(this.title)}></h4> : null)}
        {this.description && !this.isMigrated &&
          <p class="vs-text vs-mb-1 vs-pb-1 vs-icon-bundle-body" innerHTML={htmlSanitizer(this.description)}></p>}
        {this.description && this.isMigrated &&
          <div class="vs-text vs-mb-1 vs-pb-1 vs-icon-bundle-body">
            {this.shouldWrapDescriptionInPTags ? <p innerHTML={htmlSanitizer(this.description)}></p> : <div innerHTML={htmlSanitizer(this.description)}></div>}
          </div>}
        {ctaArray && ctaArray.map(content => this.renderCtaLink(content))}
      </div>
    );
  }
}
